export class HttpBodyRespModel {
	public total: number;
	public data: any;
	public status: number;

	public convert(dto: any): HttpBodyRespModel {
		this.status = dto.status;
		this.total = dto.totalRecord;
		this.data = dto ? dto : dto;

		return this;
	}
}
